export const cartLineKey = item => String(item.productId) + (item.variantId ? ':' + item.variantId : '');
